import React, { useState } from "react";
import { Drawer, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import jdpower from '../../images/svg/jdp-logo.svg';

const MobileNavMenu = ({ children, isMobile }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            {isMobile && !open && (
                <IconButton onClick={() => setOpen(true)} aria-label="open menu">
                    <MenuIcon fontSize="large" className="menu-open-icon" />
                </IconButton>
            )}
            <Drawer
                anchor="top"
                open={open}
                onClose={() => setOpen(false)}
                PaperProps={{
                    className: "menu-drawer"
                }}
                ModalProps={{
                    disableScrollLock: true
                }}
            >
                <div className="menu-drawer-content">
                    <div className="menu-header-row">
                        <div className="menu-header-logo">
                            <div className="header-logo">
                                <img src={jdpower}
                                     onClick={() => window.open('https://www.jdpower.com/consumer-resources', '_self')}
                                     alt="J.D. Power Logo"
                                     className="mobile-logo" />
                            </div>
                        </div>
                        <IconButton
                            onClick={() => setOpen(false)}
                            aria-label="close menu"
                            className="menu-close-icon-btn"
                        >
                            <CloseIcon fontSize="large" />
                        </IconButton>
                    </div>
                    <div className="menu-categories-scroll">
                        {children}
                    </div>
                </div>
            </Drawer>
            {!isMobile && children}
        </>
    );
};

export default MobileNavMenu;